import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { useLang } from "@/landing/LanguageContext";
import { trackLead } from "@/landing/pixel";

const StickyCta = () => {
  const { t, wa } = useLang();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > window.innerHeight * 0.9);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.a
          href={wa}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="sticky-cta"
          onClick={() => trackLead("sticky-cta")}
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.4 }}
          className="fixed bottom-5 left-1/2 z-40 flex -translate-x-1/2 items-center gap-3 whitespace-nowrap rounded-full bg-carbon px-6 py-3.5 font-sans text-xs tracking-[0.18em] uppercase text-cream shadow-2xl transition-colors hover:bg-earth sm:text-xs"
        >
          <MessageCircle size={16} className="text-sand" />
          {t.sticky}
        </motion.a>
      )}
    </AnimatePresence>
  );
};

export default StickyCta;
